var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'calendar_header_day': true}},[_c('div',{class:{'calendar_header_day_text': true, 'weekend': _vm.isWeekend}},[_vm._v(_vm._s(_vm.day))])])}
var staticRenderFns = []

export { render, staticRenderFns }